import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import OTP from "../../common/OTP";
import PrimaryButton from "../../common/PrimaryButton";
import FundraiserHeader from "../common/FundraiserHeader";
import SwoodleFooter from "../../common/SwoodleFooter";
import { useFormik } from "formik";
import { otpSchema } from "../../../utils/validationSchemas";
import { useDispatch, useSelector } from "react-redux";
import {
  forgetPassword,
  otpVerification,
} from "../../../services/authService.js";
import { setForgetPasswordData } from "../../../redux/slices/authSlice";

const responsiveShellStyle = {
  width: "100%",
  maxWidth: "min(1920px, calc(100vw - 2vw))",
  margin: "0 auto",
};

const OTPVerification = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const authLoading = useSelector((state) => state?.authReducer?.loading);
  const forgetData = useSelector(
    (state) => state?.authReducer?.forgetPasswordData
  );

  const formik = useFormik({
    initialValues: {
      otp: "",
    },
    validationSchema: otpSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const otpPromise = await dispatch(
          otpVerification({ otp: values?.otp, email: forgetData?.email })
        )?.unwrap();
        if (otpPromise?.success == true) {
          navigate("/user-resetPassword", {
            state: {
              email: forgetData?.email,
            },
          });
        }
      } catch (error) {
        console.log("---err---", error);
      } finally {
        setLoading(false);
      }
    },
  });

  const { otp } = formik.values;

  const {
    handleChange,
    handleBlur,
    handleSubmit,
    errors,
    touched,
    setFieldValue,
  } = formik;

  const onOtpChange = (otpValue) => {
    setFieldValue("otp", otpValue);
  };

  const handleResendClick = async () => {
    setFieldValue("otp", "");
    const forgetPromise = await dispatch(
      forgetPassword({ email: forgetData?.email })
    )?.unwrap();
    if (forgetPromise?.success === true) {
      dispatch(setForgetPasswordData({ email: forgetData?.email }));
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <FundraiserHeader />

      <div className="flex-1 flex flex-col items-center px-4 pt-16 md:pt-24">
        <form className="w-full max-w-[600px]" onSubmit={handleSubmit}>
          {/* Heading Section */}
          <div className="text-center mb-10">
            <h1 className="text-[28px] md:text-[32px] font-[700] font-poppins text-[#303030] mb-3">
              OTP Verification
            </h1>
            <p className="text-[14px] md:text-[16px] font-[400] font-poppins text-[#8C8C8C] leading-relaxed max-w-[400px] mx-auto">
              Enter the 6 digit numbers sent to your email.
            </p>
          </div>

          <div className="flex flex-col items-center">
            <div className="mb-4">
              <OTP
                value={otp}
                handleChange={onOtpChange}
                type="text"
                inputStyle={{
                  border: "none",
                  borderRadius: "8px",
                  width: "48px",
                  height: "56px",
                  fontFamily: "Poppins, sans-serif",
                  fontSize: "18px",
                  lineHeight: "24px",
                  color: "#303030",
                  background: "#F2F4F5",
                  fontWeight: "600",
                  caretColor: "#00ADEF",
                  outline: "none",
                }}
              />
            </div>

            <p className="text-center text-[14px] font-poppins text-[#303030] font-[500] mt-6">
              Don't Receive Code?{" "}
              <span 
                className="text-[#00ADEF] underline font-[600] cursor-pointer ml-1" 
                onClick={handleResendClick}
              >
                Resend Code
              </span>
            </p>

            <div className="mt-10 w-full max-w-[460px]">
              <PrimaryButton
                type="submit"
                className="w-full h-[60px] rounded-[8px] text-[18px] font-[600]"
                label="Set New Password"
                loading={loading || authLoading}
              />
            </div>
          </div>
        </form>
      </div>

      <div className="mt-16">
        <SwoodleFooter containerStyle={responsiveShellStyle} enableEntranceAnimation={true} />
      </div>
    </div>
  );
};

export default OTPVerification;
